import { PermissionType } from 'api/types/entity';
import {
  FormFooter as BaseFormFooter,
  FormFooterCancel,
  FormFooterSubmit,
} from 'components';
import { useFormPrompt, useIsFormEditable } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';
import { PermissionWrapper } from 'libs/permissions';
import { useDirectoryContext } from 'modules/directory/common/providers/DirectoryProvider/useDirectoryContext';

interface FormFooterProps {
  submitLoading?: boolean;
}

export const FormFooter = ({ submitLoading }: FormFooterProps) => {
  const editable = useIsFormEditable();
  const { onDisableEdit } = useDirectoryContext();
  const { confirmIsChanged } = useFormPrompt();
  const { dirty, setReadOnly } = useFormContext();

  const disableEditable = () => {
    confirmIsChanged(() => onDisableEdit(() => setReadOnly(true)));
  };
  return (
    <BaseFormFooter visible={editable}>
      <FormFooterCancel onClick={disableEditable} />
      <PermissionWrapper permissions={[PermissionType.Directory_UpdateOne]}>
        <FormFooterSubmit disabled={!dirty} loading={submitLoading} />
      </PermissionWrapper>
    </BaseFormFooter>
  );
};
